<template>
    <Tag :text="text" :classes="classes" />
</template>

<script>
import Tag from '@/Components/Elements/Tags/Tag.vue'
export default {
    name: 'TypeTag',

    components: {
        Tag,
    },

    props: {
        type: {
            type: Object,
            default: null,
            // has to be present if the typeName is not present
            validator: (value, props) => {
                return value != null || props.typeName != null
            },
        },
        typeName: {
            type: String,
            default: null,
            // has to be present if the type is not present
            validator: (value, props) => {
                return value != null || props.type != null
            },
        },
        classes: {
            required: false,
        },
    },

    computed: {
        text() {
            return this.typeName || this.type?.shortname || this.type?.name
        },
    },
}
</script>
